import Design from '../../components/Design/Design';

const DesignPage = () => {
  return (
    <>
      <Design />
    </>
  );
};
export default DesignPage;
